export const APP_PLATFORM_VALUES = ["ios", "android"] as const;
export const AppPlatform = {
	IOS: "ios",
	ANDROID: "android",
} as const;
export type AppPlatform = (typeof AppPlatform)[keyof typeof AppPlatform];

export const LOCALE_VALUES = ["en", "fr"] as const;
export const Locale = {
	EN: "en",
	FR: "fr",
} as const;
export type Locale = (typeof Locale)[keyof typeof Locale];

export const AUTH_METHOD_VALUES = ["email", "oauth"] as const;
export const AuthMethod = {
	EMAIL: "email",
	OAUTH: "oauth",
} as const;
export type AuthMethod = (typeof AuthMethod)[keyof typeof AuthMethod];

export const OAUTH_PROVIDER_VALUES = ["google", "apple"] as const;
export const OAuthProvider = {
	GOOGLE: "google",
	APPLE: "apple",
} as const;
export type OAuthProvider = (typeof OAuthProvider)[keyof typeof OAuthProvider];

export const GROUP_ROLE_VALUES = ["admin", "member"] as const;
export const GroupRole = {
	ADMIN: "admin",
	MEMBER: "member",
} as const;
export type GroupRole = (typeof GroupRole)[keyof typeof GroupRole];

export const INVITATION_STATUS_VALUES = ["pending", "accepted", "declined"] as const;
export const InvitationStatus = {
	PENDING: "pending",
	ACCEPTED: "accepted",
	DECLINED: "declined",
} as const;
export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus];

export const MEDIA_TYPE_VALUES = ["image", "video"] as const;
export const MediaType = {
	IMAGE: "image",
	VIDEO: "video",
} as const;
export type MediaType = (typeof MediaType)[keyof typeof MediaType];

export const MESSAGE_MEDIA_TYPE_VALUES = ["image", "video", "audio"] as const;
export const MessageMediaType = {
	IMAGE: "image",
	VIDEO: "video",
	AUDIO: "audio",
} as const;
export type MessageMediaType = (typeof MessageMediaType)[keyof typeof MessageMediaType];

export const REPORT_RESOURCE_TYPE_VALUES = ["post", "comment", "message"] as const;
export const ReportResourceType = {
	POST: "post",
	COMMENT: "comment",
	MESSAGE: "message",
} as const;
export type ReportResourceType = (typeof ReportResourceType)[keyof typeof ReportResourceType];

export const NOTIFICATION_RESOURCE_TYPE_VALUES = [
	"post",
	"comment",
	"story",
	"group",
	"message",
	"photo_roulette_game",
	"voice_guesser_game",
	"gamification",
] as const;
export const NotificationResourceType = {
	POST: "post",
	COMMENT: "comment",
	STORY: "story",
	GROUP: "group",
	MESSAGE: "message",
	PHOTO_ROULETTE_GAME: "photo_roulette_game",
	VOICE_GUESSER_GAME: "voice_guesser_game",
	GAMIFICATION: "gamification",
} as const;
export type NotificationResourceType = (typeof NotificationResourceType)[keyof typeof NotificationResourceType];

export const SUBSCRIPTION_TIER_VALUES = ["free", "family", "team"] as const;
export const SubscriptionTier = {
	FREE: "free",
	FAMILY: "family",
	TEAM: "team",
} as const;
export type SubscriptionTier = (typeof SubscriptionTier)[keyof typeof SubscriptionTier];

export const UPLOAD_CONTEXT_TYPE_VALUES = ["user_avatar", "group_avatar", "post_media", "story_media", "conversation_media"] as const;
export const UploadContextType = {
	USER_AVATAR: "user_avatar",
	GROUP_AVATAR: "group_avatar",
	POST_MEDIA: "post_media",
	STORY_MEDIA: "story_media",
	CONVERSATION_MEDIA: "conversation_media",
} as const;
export type UploadContextType = (typeof UploadContextType)[keyof typeof UploadContextType];

export const MESSAGE_TYPE_VALUES = [
	"recommendation_request",
	"recommendation_response",
	"shared_post",
	"story_comment",
	"poll",
	"system_event",
] as const;
export const MessageType = {
	RECOMMENDATION_REQUEST: "recommendation_request",
	RECOMMENDATION_RESPONSE: "recommendation_response",
	SHARED_POST: "shared_post",
	STORY_COMMENT: "story_comment",
	POLL: "poll",
	SYSTEM_EVENT: "system_event",
} as const;
export type MessageType = (typeof MessageType)[keyof typeof MessageType];

export const SYSTEM_EVENT_VALUES = ["member_joined", "member_left"] as const;
export const SystemEvent = {
	MEMBER_JOINED: "member_joined",
	MEMBER_LEFT: "member_left",
} as const;
export type SystemEvent = (typeof SystemEvent)[keyof typeof SystemEvent];

export const RECOMMENDATION_STATUS_VALUES = ["pending", "accepted", "declined"] as const;
export const RecommendationStatus = {
	PENDING: "pending",
	ACCEPTED: "accepted",
	DECLINED: "declined",
} as const;
export type RecommendationStatus = (typeof RecommendationStatus)[keyof typeof RecommendationStatus];

export const SUBSCRIPTION_STATUS_VALUES = ["active", "expired", "cancelled"] as const;
export const SubscriptionStatus = {
	ACTIVE: "active",
	EXPIRED: "expired",
	CANCELLED: "cancelled",
} as const;
export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export const NOTIFICATION_TYPE_VALUES = [
	"post_reaction",
	"comment",
	"comment_reaction",
	"reply",
	"mention",
	"group_invitation",
	"group_invitation_accepted",
	"group_member_left",
	"dm_received",
	"report_filed",
	"story_like",
	"story_comment",
	"story_comment_reaction",
	"new_post",
	"new_story",
	"banned_word_used",
	"content_reported",
	"content_removed_by_admin",
	"account_suspended",
	"photo_roulette_invite",
	"voice_guesser_invite",
	"walkie_talkie_started",
	"badge_unlocked",
	"quest_completed",
	"level_up",
	"streak_milestone",
	"streak_at_risk",
	"weekly_recap",
] as const;
export const NotificationType = {
	POST_REACTION: "post_reaction",
	COMMENT: "comment",
	COMMENT_REACTION: "comment_reaction",
	REPLY: "reply",
	MENTION: "mention",
	GROUP_INVITATION: "group_invitation",
	GROUP_INVITATION_ACCEPTED: "group_invitation_accepted",
	GROUP_MEMBER_LEFT: "group_member_left",
	DM_RECEIVED: "dm_received",
	REPORT_FILED: "report_filed",
	STORY_LIKE: "story_like",
	STORY_COMMENT: "story_comment",
	STORY_COMMENT_REACTION: "story_comment_reaction",
	NEW_POST: "new_post",
	NEW_STORY: "new_story",
	BANNED_WORD_USED: "banned_word_used",
	CONTENT_REPORTED: "content_reported",
	CONTENT_REMOVED_BY_ADMIN: "content_removed_by_admin",
	ACCOUNT_SUSPENDED: "account_suspended",
	PHOTO_ROULETTE_INVITE: "photo_roulette_invite",
	VOICE_GUESSER_INVITE: "voice_guesser_invite",
	WALKIE_TALKIE_STARTED: "walkie_talkie_started",
	BADGE_UNLOCKED: "badge_unlocked",
	QUEST_COMPLETED: "quest_completed",
	LEVEL_UP: "level_up",
	STREAK_MILESTONE: "streak_milestone",
	STREAK_AT_RISK: "streak_at_risk",
	WEEKLY_RECAP: "weekly_recap",
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export const DM_SCOPE_VALUES = ["dm", "group"] as const;
export const DmScope = {
	DM: "dm",
	GROUP: "group",
} as const;
export type DmScope = (typeof DmScope)[keyof typeof DmScope];

export const NotificationCategory = {
	MESSAGE_REPLY: "message_reply",
} as const;
export type NotificationCategory = (typeof NotificationCategory)[keyof typeof NotificationCategory];

export const NotificationActionIdentifier = {
	REPLY: "reply",
} as const;
export type NotificationActionIdentifier = (typeof NotificationActionIdentifier)[keyof typeof NotificationActionIdentifier];
